import type { BattleSeat } from "@loot-os/api-contract";

/** How a seat reads to the viewer: You, a bot, another player, or empty. */
export function seatLabel(seat: BattleSeat, viewerEndUserId: string | null | undefined): string {
  if (seat.kind === "empty") return "Empty seat";
  if (seat.kind === "bot") return "Bot";
  if (seat.endUser && seat.endUser.id === viewerEndUserId) return "You";
  return seat.endUser?.displayName ?? "Player";
}
